import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import React, { useCallback, useEffect, useState } from 'react';
import {
  ArrowBack,
  CalendarTodayRounded,
  PermIdentityRounded,
  MailOutlineRounded,
  EditRounded,
  RemoveCircleRounded,
  LinkedIn,
  SecurityRounded,
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SwipeableDrawer,
  Tooltip,
} from '@mui/material';
import dayjs from 'dayjs';

import {
  Board,
  Company,
  User,
  deactivateUserRequest,
  getActiveBoardsByCompanyId,
  getCompaniesByUserIdOnDetailsBoardsRequest,
  getUserByIdRequest,
} from '../../../services/requests';

import TenLogoHorizontalBlue from '../../../assets/horizontal-blue-logo.svg';
import {
  Boards,
  Companies,
  Container,
  ContainerCompanies,
  Div,
  Header,
  Logo,
  SectionBoard,
  SectionUser,
  Title,
} from './styles';

import { EditarMembro } from '../EditarMembro';

import { stringAvatar } from '../../../utils/avatarGenerator';

import useAuthStore from '../../../store/auth';
import useCompanyStore from '../../../store/companies';
import useUserStore from '../../../store/users';

import { LogoCompanies } from '../../../components/LogoCompanies';

export const DetalhesUsuario = () => {
  const navigate = useNavigate();
  const params = useParams();

  const userStore = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const setSelectedUser = useUserStore(state => state.setSelectedUser);

  const [listagemBoard, setListagemBoard] = useState<Board[]>([]);
  const [openDrawerAddMember, setOpenDrawerAddMember] = useState(false);
  const [userToEdit, setUserToEdit] = useState({} as any);
  const [listagemBoardsPorUsuario, setListagemBoardsPorUsuario] = useState<
    Board[]
  >([]);
  const [listagemEmpresasPorUsuario, setListagemEmpresasPorUsuario] = useState<
    Company[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [openModalDesactiveUser, setOpenModalDesactiveUser] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState<User>(
    {} as User,
  );

  const loadCompaniesByUser = useCallback(async () => {
    try {
      const response = await getCompaniesByUserIdOnDetailsBoardsRequest(
        params?.id as string,
        '',
        '0',
        '100',
      );

      if (response?.status === 200) {
        const listagemEmpresasPorUsuarioAtivas =
          response?.data?.companies.filter((company: any) => company?.status);
        setListagemEmpresasPorUsuario(listagemEmpresasPorUsuarioAtivas);
      }
    } catch (err) {
      console.log(err);
    }
  }, [params?.id]);

  useEffect(() => {
    if (params?.id) {
      loadCompaniesByUser();
    }
  }, [params?.id]);

  useEffect(() => {
    if (listagemBoard?.length > 0) {
      const boardFiltrado = listagemBoard.filter(e =>
        e?.members_ids?.includes(params?.id as string),
      );

      setListagemBoardsPorUsuario(boardFiltrado);
    }
  }, [listagemBoard, params]);

  const loadActiveBoardsByCompanyId = useCallback(async () => {
    setLoading(true);
    try {
      setLoading(true);
      const responseActives = await getActiveBoardsByCompanyId(
        selectedCompany?.id as string,
        '',
        userStore?.id as string,
      );

      if (responseActives?.status === 200) {
        setListagemBoard(responseActives?.data);
      }
    } catch (error) {
      console.error('Error LoadBoards', error);
    }
  }, [selectedCompany?.id, userStore]);

  const getUserById = useCallback(
    async (id: string) => {
      setLoading(true);
      try {
        const response = await getUserByIdRequest(id);

        if (response?.status === 200) {
          const userInCompany = selectedCompany?.users?.find(u => u?.id === id);

          if (userInCompany) {
            const user = {
              ...response?.data,
              profile: userInCompany?.profile,
            };

            setSelectedUser(user as any);
            setUsuarioSelecionado(user as any);
          }
        }
      } catch (err) {
        console.error('Error getUserById', err);
      }
    },
    [selectedCompany?.users, setSelectedUser],
  );

  useEffect(() => {
    if (params?.id && selectedCompany?.id && userStore) {
      Promise.all([
        getUserById(params?.id),
        loadActiveBoardsByCompanyId(),
      ]).finally(() => setLoading(false));
    }
  }, [params?.id, selectedCompany?.id, userStore]);

  const handleEditUser = useCallback((usr: any) => {
    setUserToEdit(usr);
    setOpenDrawerAddMember(true);
  }, []);

  const handleDesactiveUser = useCallback(async () => {
    try {
      if (userStore?.profile === 'UN1' || userStore?.profile === 'UN2') {
        const response = await deactivateUserRequest(
          params?.id as string,
          selectedCompany?.id as string,
          userStore?.id as string,
        );

        // console.log({ response });

        if (response?.status === 200) {
          setOpenModalDesactiveUser(false);
          navigate('/home/gestao-usuarios');
        }
      } else {
        toast.warning('Você não tem permissão para desativar usuários');
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    navigate,
    params?.id,
    selectedCompany?.id,
    userStore?.id,
    userStore?.profile,
  ]);

  const listEdit = () => (
    <EditarMembro
      userEdit={userToEdit}
      setOpenDrawerAddMember={setOpenDrawerAddMember}
      setUserEdit={setUsuarioSelecionado}
    />
  );

  return loading ? (
    <Container>
      <CircularProgress />
    </Container>
  ) : (
    <Box
      width="100%"
      sx={{
        padding: '42px 30px 42px 30px',
        background: '#F5F5F5',
        overflow: 'overlay',
      }}
    >
      <>
        <Header>
          <Button
            className="btn-back"
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            <ArrowBack /> Voltar
          </Button>
        </Header>
        <SectionUser
          sx={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box display="flex" flexDirection="column" gap="10px">
            <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="20px"
              marginBottom="10px"
            >
              {usuarioSelecionado?.avatar_url ? (
                <Avatar sx={{ width: '60px', height: '60px' }}>
                  <img
                    src={usuarioSelecionado?.avatar_url as string}
                    alt="Foto de Perfil"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center center',
                    }}
                  />
                </Avatar>
              ) : (
                <Avatar
                  {...stringAvatar(usuarioSelecionado?.name)}
                  sx={{ width: '60px', height: '60px', fontSize: '22px' }}
                />
              )}
              <Box className="name-user">{usuarioSelecionado?.name}</Box>
              {usuarioSelecionado?.status === 'US1' && (
                <Box className="active">Ativo</Box>
              )}

              {usuarioSelecionado?.status === 'US2' && (
                <Box className="desactive">Desativado</Box>
              )}
              {usuarioSelecionado?.status === 'US3' && (
                <Box className="pendent">Pendente</Box>
              )}
            </Div>
            <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="10px"
            >
              <CalendarTodayRounded />
              <Box className="text-details">
                Cadastrado em:{' '}
                {dayjs(usuarioSelecionado?.created_at || new Date()).format(
                  'DD/MM/YYYY',
                )}
              </Box>
            </Div>
            <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="10px"
            >
              <MailOutlineRounded />
              <Box className="text-details">
                E-mail: {usuarioSelecionado?.email}
              </Box>
            </Div>
            <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="10px"
            >
              <PermIdentityRounded />
              <Box className="text-details">
                CPF:{' '}
                {usuarioSelecionado?.doc === null
                  ? 'Nenhum documento adicionado'
                  : usuarioSelecionado?.doc}
              </Box>
            </Div>
            <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="10px"
            >
              <LinkedIn sx={{ fontSize: '26px' }} />
              <Box className="text-details">
                {' '}
                {usuarioSelecionado?.linkedIn === null
                  ? 'Link do perfil não adicionado'
                  : usuarioSelecionado?.linkedIn}
              </Box>
            </Div>
            <Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="10px"
            >
              <SecurityRounded />
              <Box className="text-details">
                Permissão: {usuarioSelecionado?.profile === 'UN2' && 'Admin'}
                {usuarioSelecionado?.profile === 'UN3' && 'Membro'}
                {usuarioSelecionado?.profile === 'UN4' && 'Convidado'}
              </Box>
            </Div>
          </Box>
          <Box display="flex" flexDirection="column" gap="10px">
            {userStore?.profile === 'UN1' || userStore?.profile === 'UN2' ? (
              <>
                <React.Fragment key="right">
                  {usuarioSelecionado?.status === 'US1' && (
                    <Button
                      variant="contained"
                      onClick={() => handleEditUser(usuarioSelecionado)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '6px 16px 6px 12px',
                        height: '40px',
                      }}
                      className="btn-users"
                    >
                      <EditRounded />
                      <Box className="text-details">Permissionamento</Box>
                    </Button>
                  )}
                  {usuarioSelecionado?.status === 'US3' && (
                    <Button
                      variant="contained"
                      onClick={() => handleEditUser(usuarioSelecionado)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '6px 16px 6px 12px',
                        height: '40px',
                      }}
                      className="btn-users"
                    >
                      <EditRounded />
                      <Box className="text-details">Permissionamento</Box>
                    </Button>
                  )}
                </React.Fragment>
                <SwipeableDrawer
                  className="drawer"
                  anchor="right"
                  open={openDrawerAddMember}
                  onClose={() => setOpenDrawerAddMember(false)}
                  onOpen={() => setOpenDrawerAddMember(true)}
                  ModalProps={{
                    keepMounted: true,
                  }}
                >
                  {listEdit()}
                </SwipeableDrawer>
              </>
            ) : (
              ''
            )}
            {userStore?.profile === 'UN1' || userStore?.profile === 'UN2' ? (
              <Button
                variant={
                  usuarioSelecionado?.status === 'US2'
                    ? 'contained'
                    : 'outlined'
                }
                color="error"
                onClick={
                  usuarioSelecionado?.status === 'US2'
                    ? () => setOpenModalDesactiveUser(false)
                    : () => setOpenModalDesactiveUser(true)
                }
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '6px 16px 6px 12px',
                  height: '40px',
                }}
                className="btn-users"
              >
                {usuarioSelecionado?.status === 'US2' ? (
                  <Box className="text-details">Usuário desativado</Box>
                ) : (
                  <Box
                    className="text-details"
                    display="flex"
                    alignItems="center"
                    gap="10px"
                  >
                    <RemoveCircleRounded />
                    Remover Acesso
                  </Box>
                )}
              </Button>
            ) : (
              ''
            )}

            <Dialog
              open={openModalDesactiveUser}
              onClose={() => setOpenModalDesactiveUser(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              id="dialog-main"
            >
              <DialogTitle id="alert-dialog-title">
                Desativar Usuário
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Ao remover, o usuário não terá mais acesso a nenhuma
                  informação desta empresa. Deseja prosseguir?
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ padding: '20px' }}>
                <Button
                  onClick={() => setOpenModalDesactiveUser(false)}
                  variant="text"
                  sx={{ color: '#9E9E9E' }}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={handleDesactiveUser}
                  autoFocus
                  color="error"
                  variant="contained"
                >
                  Confirmar
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </SectionUser>
        <SectionUser sx={{ marginTop: '20px' }}>
          <Title>Boards</Title>

          {listagemBoardsPorUsuario?.length <= 0 ? (
            <Box className="section-board">
              Nenhum board adicionado até o momento.
            </Box>
          ) : (
            <SectionBoard>
              {listagemBoardsPorUsuario?.map(e => (
                <Boards key={e?.id} sx={{ borderColor: e?.color }}>
                  <Div
                    className="text-title-board"
                    display="flex"
                    flexDirection="row"
                    gap="10px"
                    width="100%"
                  >
                    <Tooltip title={e?.title}>
                      <span> {e?.title} </span>
                    </Tooltip>
                  </Div>
                  <Box className="text-member-board">
                    {e?.members?.length}{' '}
                    {e?.members?.length === 1 ? 'membro' : 'membros'}
                  </Box>
                </Boards>
              ))}
            </SectionBoard>
          )}
        </SectionUser>
        <SectionUser sx={{ marginTop: '20px' }}>
          <Title>Empresas</Title>

          {listagemEmpresasPorUsuario?.length <= 0 ? (
            <Box className="section-board">
              Usuário não faz parte de nenhuma empresa até o momento.
            </Box>
          ) : (
            <ContainerCompanies>
              {listagemEmpresasPorUsuario?.map(c => (
                <Companies key={c?.id}>
                  <Logo>
                    <LogoCompanies
                      url={c.logo_url ? c.logo_url : TenLogoHorizontalBlue}
                      height="100%"
                      maxWidth="100%"
                      boxWidth="100%"
                      width=""
                      justifyContent="center"
                    />
                  </Logo>
                  <Tooltip title={c?.name}>
                    <Box className="text-company">
                      {c?.fancy_name ?? c?.name}
                    </Box>
                  </Tooltip>
                </Companies>
              ))}
            </ContainerCompanies>
          )}
        </SectionUser>
      </>
    </Box>
  );
};
